export function notificationsNamespace(http) {
    return {
        /** List notifications → unwraps to `{ notifications, unread_count }`. */
        list(opts) {
            return http.get('/notifications', { signal: opts?.signal });
        },
        /** Mark a single notification read. */
        markRead(notificationId) {
            return http.post(`/notifications/${notificationId}/read`);
        },
        /** Mark all notifications read. */
        markAllRead() {
            return http.post('/notifications/read-all');
        },
    };
}
//# sourceMappingURL=notifications.js.map